var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-item-info"},[_c('span',{staticClass:"nav-item-info__title"},[_vm._v(_vm._s(_vm.$t('message.orderDetails.orderSource'))+":")]),(_vm.isLoading)?_c('b-spinner',{staticClass:"nav-item-info__spinner",attrs:{"small":""}}):_c('div',{staticClass:"menu-source-info-block",style:({
      'background-color': _vm.getSourceColor(_vm.menuSource),
      color: _vm.getButtonTextColor(_vm.menuSource),
    })},[_c('span',[_vm._v(_vm._s(_vm.menuTranslated))]),(_vm.externalDisplayId)?_c('span',[_vm._v("("+_vm._s(_vm.externalDisplayId)+")")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }